/**
 * `/plans/nowy` — the plan builder, on a plan that does not exist on the server yet.
 *
 * A path, a search validator and a screen, exactly like its numeric sibling. A STATIC segment, so
 * TanStack Router ranks it above `/plans/$planId` and the numeric route is untouched — no magic
 * string inside a path parameter, and `/plans/nowy` cannot be mistaken for a plan whose id is
 * "nowy".
 *
 * **No loader and no read.** The create modal writes the seed into the document store and navigates
 * here; there is nothing on the server to fetch until the trainer's first Zapisz, which POSTs the
 * tree and replaces this address with `/plans/<newId>`. Arriving here with an empty store — a
 * reload, a bookmark, a second tab — is a real state: the screen offers back the copy this device
 * kept of the unsaved plan (`entities/plan-draft/lib/unsavedPlanRecord.ts`), and says the plan is
 * gone when there is none.
 *
 * It registers the SAME `validateSearch` as the numeric route, because the builder understands the
 * same parameters wherever it is mounted — the phase, the open day and the dock's host are the
 * builder's own address, not the plan's.
 */

import { createFileRoute } from '@tanstack/react-router';

import { PlanBuilderScreen, validatePlanBuilderSearch } from '~/pages/plan-builder';

export const Route = createFileRoute('/_shell/plans/nowy')({
  validateSearch: validatePlanBuilderSearch,
  component: NewPlanRoute,
});

function NewPlanRoute() {
  return <PlanBuilderScreen target={{ kind: 'draft' }} />;
}
